<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">ITENS</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblDespesas"
                            :itens="itens"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :mostrarFiltro="false"
                        >
                            <template slot="quantidade" slot-scope="data">
                                {{ data.quantidade | currency2 }}
                            </template>
                            <template slot="precoUnitario" slot-scope="data">
                                {{ data.precoUnitario | currency }}
                            </template>
                            <template slot="valorUnitario" slot-scope="data">
                                {{ data.valorUnitario | currency }}
                            </template>
                            <template slot="valor" slot-scope="data">
                                {{ data.valor | currency }}
                            </template>
                        </app-tabela>
                    </b-card-body>
                    <b-card-footer>
                        <app-btn-voltar></app-btn-voltar>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>


</template>

<script>

export default {
    props: {
        itens: {
            type: Array,
            default: () => ({})
        }
    },

    data() {
        return { 
            campos: [
                {
                    key: 'nomeProduto',
                    label: 'Produto',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeNatureza',
                    label: 'Natureza',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeUnidade',
                    label: 'Unidade',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valor',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 0,
        }
    }
}
</script>